import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { get } from 'lodash'

import { getDefaultHeaders } from './getDefaultHeaders'

async function request<T>(opts: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  const { headers, ...rest } = opts
  const defaultHeaders = getDefaultHeaders()
  return axios({
    ...defaultHeaders,
    headers: {
      ...(get(defaultHeaders, 'headers') || {}),
      ...headers,
    },
    ...rest,
  })
}

export default request
